/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungSpalteDto } from '../../models/aggregierte-auswertung-spalte-dto';

export interface GetAllAggregierteAuswertungSpalten$Json$Params {
}

export function getAllAggregierteAuswertungSpalten$Json(http: HttpClient, rootUrl: string, params?: GetAllAggregierteAuswertungSpalten$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllAggregierteAuswertungSpalten$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>;
    })
  );
}

getAllAggregierteAuswertungSpalten$Json.PATH = '/v1/aggregierteAuswertung/layouts/spalten';
